module.exports = __webpack_public_path__ + "img/beside.be5030ca.webp";